export const epgChannels = [
  {
    uuid: "368358e0-25ca-4ec9-90c6-db659968f8a2",
    type: "channel",
    title: "Main Hall",
    country: "USA",
    provider: 7427,
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/480px-Unofficial_JavaScript_logo_2.svg.png",
    year: 2002,
  },
  {
    uuid: "1c32397f-fb76-45f5-aa05-592ad4118e6d",
    type: "channel",
    title: "DevTrends",
    country: "USA",
    provider: 9749,
    logo: "https://github.com/aarjithn/frontend-logos/blob/master/app/images/logos/1ec9cb73f2aac4884b7014ca4a7d8789.png?raw=true",
    year: 2002,
  },
  {
    uuid: "fb042781-4228-4080-95b9-229e3bd53b6a",
    type: "channel",
    title: "Inspire Dev",
    country: "USA",
    provider: 2764,
    logo: "https://raw.githubusercontent.com/gilbarbara/logos/80c549990a0f513dcbaf3c9eab6a1a620df76088/logos/nodejs-icon.svg",
    year: 2002,
  },
  {
    uuid: "be37b383-18b2-4ab5-8973-263a38add4fc",
    type: "channel",
    title: "Marketing",
    country: "USA",
    provider: 5380,
    logo: "https://raw.githubusercontent.com/gilbarbara/logos/80c549990a0f513dcbaf3c9eab6a1a620df76088/logos/nestjs.svg",
    year: 2002,
  },
  {
    uuid: "e7f834ae-65e6-4a6d-a9fe-51f1443b79b0",
    type: "channel",
    title: "Management",
    country: "USA",
    provider: 5380,
    logo: "https://raw.githubusercontent.com/gilbarbara/logos/80c549990a0f513dcbaf3c9eab6a1a620df76088/logos/docker-icon.svg",
    year: 2002,
  },
  {
    uuid: "d0fae027-2199-4442-937c-56ad4fa5ed87",
    type: "channel",
    title: "Machine Learning",
    country: "USA",
    provider: 5066,
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Angular_full_color_logo.svg/640px-Angular_full_color_logo.svg.png",
    year: 2002,
  },
  {
    uuid: "d0fae027-2199-4442-937c-56ad4fa5ed873",
    type: "channel",
    title: "Deno",
    country: "USA",
    provider: 5066,
    logo: "https://upload.wikimedia.org/wikipedia/commons/e/e8/Deno_2021.svg",
    year: 2002,
  },
];
